import { render, staticRenderFns } from "./selectReason.vue?vue&type=template&id=64ca8e0e"
import script from "./selectReason.vue?vue&type=script&lang=js"
export * from "./selectReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports